import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { hotComics, brandAdvantages, testimonials, faqItems } from '@/mocks/comics';

function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20art%20background%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20abstract%20brush%20strokes%2C%20subtle%20manga%20panel%20texture%2C%20elegant%20minimalist%20composition%2C%20gentle%20natural%20light%2C%20artistic%20illustration%20with%20warm%20golden%20tones%2C%20clean%20sophisticated%20aesthetic%2C%20Korean%20ink%20wash%20painting%20influence&width=1920&height=900&seq=hero-bg-home&orientation=landscape"
        alt="韩漫网背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/40 via-primary-900/20 to-primary-900/50" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight">
              韩漫全集大全
              <br />
              <span className="text-accent-400">下拉式免费观看</span>
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-50/70 leading-relaxed max-w-lg mx-auto lg:mx-0">
              无广告纯净阅读体验，随时随地畅享海量韩漫内容。全站免费，每日更新，给您最纯粹的漫画世界。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/category"
                className="group inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-lg text-sm font-semibold transition-all duration-300 whitespace-nowrap"
              >
                立即开始阅读
                <span className="w-7 h-7 border border-background-50/40 rounded flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </Link>
              <Link
                to="/about"
                className="text-background-50/80 hover:text-background-50 text-sm font-medium transition-colors duration-200 whitespace-nowrap"
              >
                了解更多 →
              </Link>
            </div>
          </div>

          <div className="hidden lg:flex justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Stack%20of%20Korean%20manhwa%20book%20covers%20with%20warm%20lighting%2C%20elegant%20arrangement%2C%20soft%20shadows%2C%20cream%20background%2C%20golden%20accents%2C%20artistic%20product%20photography%2C%20clean%20minimalist%20composition&width=500&height=700&seq=hero-comic-stack&orientation=portrait"
              alt="韩漫精选"
              className="w-auto max-h-[500px] object-contain rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function HotComicsSection() {
  return (
    <section className="bg-primary-500 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 border border-background-50/30 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              本周热播
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mt-4">
              热门连载推荐
            </h2>
          </div>
          <Link
            to="/category"
            className="text-background-50/70 hover:text-background-50 text-sm font-medium transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
                <img
                  src={comic.coverUrl}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫网`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {comic.status === '连载中' && (
                  <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded">
                    {comic.status}
                  </span>
                )}
                {comic.status === '已完结' && (
                  <span className="absolute top-2 left-2 bg-background-700/80 text-background-50 text-xs px-2 py-0.5 rounded">
                    {comic.status}
                  </span>
                )}
              </div>
              <div className="mt-3">
                <h3 className="text-background-50 font-semibold text-sm md:text-base truncate group-hover:text-accent-400 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-background-50/50 text-xs mt-1">
                  更新至第 {comic.chapterCount} 话 · {comic.updateDate}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-secondary-500 text-xs font-medium tracking-wider uppercase">
            平台特色
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
            下拉式阅读
            <br />
            零广告体验
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {brandAdvantages.slice(0, 6).map((advantage) => (
            <div
              key={advantage.title}
              className="bg-background-50 rounded-lg p-6 md:p-7 transition-all duration-300 hover:bg-background-50/80"
            >
              <div className="w-10 h-10 flex items-center justify-center text-foreground-800 mb-4">
                <i className={`${advantage.icon} text-2xl`} aria-label={advantage.title}></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-base mb-2">
                {advantage.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full">
            读者评价
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-4">
            真实读者反馈
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="break-inside-avoid bg-background-100 rounded-lg p-5 mb-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-foreground-900 font-semibold text-sm">
                    {item.name}
                  </p>
                  <p className="text-foreground-500 text-xs">{item.username}</p>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-10">
          常见问题
        </h2>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                type="button"
                className="w-full flex items-center justify-between px-5 py-4 text-left"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-foreground-900 font-medium text-sm pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComicsSection />
        <FeatureSection />
        <TestimonialsSection />
        <FaqSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫网 - 韩漫画免费全集大全',
            description: '韩漫画免费，韩漫全集大全，漫画下拉式无广告，随时随地畅享各种漫画内容',
            url: 'http://bwpntxx.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫网',
              url: 'http://bwpntxx.cn/',
            },
          }),
        }}
      />
    </>
  );
}